var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliResponsiveDialog", {
    ref: "dialog",
    attrs: { "mobile-scroll": false, title: "New Relationship" },
    on: {
      reset: function ($event) {
        return _vm.$emit("reset")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "subtitle",
        fn: function () {
          return [_vm._v(_vm._s(_vm.subtitle))]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-form",
                  {
                    ref: "form",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submit.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-4" },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "w-full",
                            class: { "gap-4": _vm.$vuetify.breakpoint.xs },
                            attrs: { "no-gutters": "" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                class: {
                                  "pr-2": _vm.$vuetify.breakpoint.smAndUp,
                                },
                                attrs: { cols: "12", sm: "6" },
                              },
                              [
                                _c("SoliText", {
                                  attrs: {
                                    icon: "person",
                                    label: "First Name",
                                    rules: _vm.rules_required,
                                    hideDetails: "auto",
                                    error: _vm.errors?.first_name,
                                  },
                                  model: {
                                    value: _vm.form.first_name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "first_name", $$v)
                                    },
                                    expression: "form.first_name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              {
                                class: {
                                  "pl-2": _vm.$vuetify.breakpoint.smAndUp,
                                },
                                attrs: { cols: "12", sm: "6" },
                              },
                              [
                                _c("SoliText", {
                                  attrs: {
                                    icon: "people",
                                    label: "Last Name",
                                    rules: _vm.rules_required,
                                    hideDetails: "auto",
                                    error: _vm.errors?.last_name,
                                  },
                                  model: {
                                    value: _vm.form.last_name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "last_name", $$v)
                                    },
                                    expression: "form.last_name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("SoliBirthday", {
                          attrs: {
                            min: _vm.minDate,
                            max: _vm.maxDate,
                            label: "Birthday",
                            required: "",
                            "hide-details": "auto",
                          },
                          model: {
                            value: _vm.form.birthday,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "birthday", $$v)
                            },
                            expression: "form.birthday",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-select", {
                          attrs: {
                            items: _vm.relationshipOptions,
                            "item-text": "relation",
                            label: "Relationship",
                            "return-object": "",
                            outlined: "",
                            dense: "",
                            rules: _vm.rules_select,
                            "prepend-inner-icon": "handshake",
                          },
                          model: {
                            value: _vm.form.relation,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "relation", $$v)
                            },
                            expression: "form.relation",
                          },
                        }),
                        _vm._v(" "),
                        _c("SoliBtn", {
                          attrs: {
                            text: "Add Relationship",
                            icon: "person_add",
                            block: "",
                            gradient: "gradient-blue",
                            loading: _vm.loading,
                            type: "submit",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }